import {
  ListProps as MantineListProps,
  List as MantineList,
  ListItemProps as MantineListItemProps,
  ListItem as MantineListItem,
} from '@mantine/core';

export type ListProps = MantineListProps;
export type ListItemProps = MantineListItemProps;

export const List = MantineList;
List.displayName = 'List';

export const ListItem = MantineListItem;
ListItem.displayName = 'ListItem';

// Attach subcomponent to List for dot notation access
List.Item = ListItem;
